import { render } from "./ProductFamily.vue?vue&type=template&id=40924826&scoped=true"
import script from "./ProductFamily.vue?vue&type=script&lang=js"
export * from "./ProductFamily.vue?vue&type=script&lang=js"

import "./ProductFamily.vue?vue&type=style&index=0&id=40924826&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40924826"]])

export default __exports__